// Funnel Machine Selectors
// context getters
export const getQuestionMachineServiceReference = state => state?.children?.questionMachine
export const getProgressBarDisable = state => state.context?.interfaceOptions?.disableProgressBar
export const getQuestionGroups = state => state.context?.question_groups
export const getAccordionActive = state => state?.context?.accordion_active
export const getIntroduction = state => state?.context?.introduction
export const getIntroEnabled = state => state?.context?.introEnabled
export const verifyFunnelMachineIsInIntro = state => state.matches('intro')
// state matchers
export const verifyFunnelMachineIsInLoading = state => state.matches('loading')
export const verifyFunnelMachineIsInIdle = state => state.matches('idle')
export const verifyFunnelMachineIsInErrorLoading = state => state.matches('errorLoading')
export const verifyQuestionMachineIsReady = state => state.matches('started')
